// FILECONTENT_START src/common/components/Inputs/RadioGroup/index.ts
import RadioGroup from "./RadioGroup";
export default RadioGroup;
export type { RadioGroupProps } from "./RadioGroup";

// FILECONTENT_END src/common/components/Inputs/RadioGroup/index.ts